// extracted by mini-css-extract-plugin
module.exports = {"dpu-detail-A":"A_dpu-detail-A__DRuzi"};